const CLOUDINARY_CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME ||
  process.env.REACT_APP_CLOUDINARY_CLOUD ||
  "";

const CLOUDINARY_FETCH_BASE = CLOUDINARY_CLOUD_NAME
  ? `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/fetch`
  : "";

const isBrowser = typeof window !== "undefined";

const isSvg = (src) => /\.svg(\?|#|$)/i.test(src);

const getAbsoluteUrl = (src) => {
  if (!src || typeof src !== "string") return src;
  if (/^(data:|blob:|mailto:|tel:)/i.test(src)) return src;
  if (/^https?:\/\//i.test(src)) return src;
  if (src.startsWith("//")) {
    return `${isBrowser ? window.location.protocol : "https:"}${src}`;
  }
  if (!isBrowser) return src;

  return new URL(src, window.location.origin).toString();
};

const shouldSkipCloudinary = (src) => {
  if (!src || typeof src !== "string") return true;
  if (!CLOUDINARY_FETCH_BASE) return true;
  if (/res\.cloudinary\.com/i.test(src)) return true;
  if (/^(data:|blob:)/i.test(src)) return true;
  if (isSvg(src)) return true;

  return false;
};

export const cloudinaryImage = (
  src,
  { width, height, quality = "auto", crop = "limit", format = "auto" } = {}
) => {
  if (shouldSkipCloudinary(src)) return src;

  const absoluteUrl = getAbsoluteUrl(src);
  if (!/^https?:\/\//i.test(absoluteUrl)) return src;
  const { hostname } = new URL(absoluteUrl);
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".local")
  ) {
    return src;
  }

  const transforms = [`f_${format}`, `q_${quality}`];

  if (crop) transforms.push(`c_${crop}`);
  if (width) transforms.push(`w_${width}`);
  if (height) transforms.push(`h_${height}`);

  return `${CLOUDINARY_FETCH_BASE}/${transforms.join(",")}/${encodeURIComponent(
    absoluteUrl
  )}`;
};

export const cloudinaryImages = (items, options) =>
  items.map((item) => ({
    ...item,
    src: cloudinaryImage(item.src, {
      width:
        options?.width ||
        (typeof item.width === "string" ? parseInt(item.width, 10) : item.width),
      height:
        options?.height ||
        (typeof item.height === "string"
          ? parseInt(item.height, 10)
          : item.height),
      ...options,
    }),
  }));
